import type { CSSProperties, HTMLAttributes, Ref } from 'react'
import type { VariantProps } from 'tailwind-variants'

import { cn } from '@gto/ui/cn'

import { skeletonVariants } from './skeleton.styles'

type SkeletonVariantProps = VariantProps<typeof skeletonVariants>

type SkeletonProps = Omit<HTMLAttributes<HTMLSpanElement>, 'children'> &
  SkeletonVariantProps & {
    /** Width in pixels (number) or CSS value (string like '100%') */
    width?: number | string
    /** Height in pixels (number) or CSS value (string like '100%') */
    height?: number | string
    /** Ref for DOM access */
    ref?: Ref<HTMLSpanElement>
  }

const toCssValue = (value: number | string | undefined): string | undefined => {
  if (value == null) {
    return undefined
  }

  return typeof value === 'number' ? `${value}px` : value
}

const Skeleton = ({
  className,
  variant = 'text',
  animation = 'wave',
  width,
  height,
  style,
  ref,
  ...props
}: SkeletonProps) => {
  const resolvedHeight = height ?? (variant === 'text' ? '1.2em' : undefined)

  const inlineStyle: CSSProperties = {
    width: toCssValue(width),
    height: toCssValue(resolvedHeight),
    ...style,
  }

  return (
    <span
      ref={ref}
      className={cn(skeletonVariants({ variant, animation }), className)}
      style={inlineStyle}
      {...props}
    />
  )
}

export { Skeleton }
export type { SkeletonProps }
